import { Injectable, inject } from '@angular/core';
import { YmService } from './ym.service';

@Injectable({ providedIn: 'root' })
export class YmInitializer {
  private readonly ymService = inject(YmService);

  init(): void {
    this.ymService.init();
  }
}
